var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigtemppictOwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31.86 44.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Nouvelle_nuance_de_motif_2);}.cls-2{fill:none;}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "Nouvelle_nuance_de_motif_2",
    x: 0,
    y: 0,
    width: 94.07,
    height: 94.07,
    patternTransform: "translate(-18809.61 -24545.22) rotate(-180) scale(1.64)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 94.07 94.07"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 94.07,
    height: 94.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    width: 94.07,
    height: 94.07
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.53,17.8L15.93,6.41l11.4,11.4c.51,.51,1.19,.77,1.87,.77s1.36-.26,1.88-.78c1.04-1.04,1.04-2.72,0-3.75L17.81,.78c-1.04-1.04-2.72-1.04-3.75,0L.78,14.05c-1.04,1.04-1.04,2.72,0,3.75s2.72,1.03,3.75,0Zm9.52,26.06c1.04,1.04,2.72,1.04,3.75,0l13.27-13.27c1.04-1.04,1.04-2.72,0-3.75s-2.72-1.04-3.75,0l-11.4,11.39L4.53,26.83c-.51-.51-1.19-.77-1.87-.77s-1.36,.26-1.88,.78c-1.04,1.04-1.04,2.72,0,3.75l13.27,13.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigtemppictOwhite);
export default __webpack_public_path__ + "static/media/NAVIG TEMP PICTO white.3ce9f92f516b5374897b89d13306a9e0.svg";
export { ForwardRef as ReactComponent };